import { Anchor, Box, HStack, Span } from '@bpba/ui-components';
import { SvgData } from '@bpba/modules-components';
import { typography, TypographyProps } from 'styled-system';
import styled from 'styled-components';
import { FOOTER_DATA } from '../../constants/data';

export const Redes = () => {
  const redes: SvgData[] = FOOTER_DATA.redes.map((item) => {
    return SvgData.fromJsonObject(item);
  });

  return (
    <Box
      marginBottom={['14px', '0px']}
      width={'100%'}
      flexDirection={['row', 'column', null, 'column']}
      alignItems={['center', 'flex-start', null, null]}
      justifyContent={['flex-start', 'center', null, 'flex-start']}
    >
      <>
        <StyledSpan
          marginRight={['5px', '10px', null, '0px']}
          marginBottom={[0, '9px', '11px', '9px']}
          lineHeight={[null, null, '16px', '14px']}
        >
          Seguinos en:
        </StyledSpan>
        <HStack width={'fit-content'} margin={['10px 0px', '6px 0px 14px 0px', '7px 0px 13px 0px', '0px 5px 0px 0px']}>
          {redes?.map((item, key) => {
            return (
              item?.icono?.trim()?.length > 0 && (
                <SvgContainer key={key}>
                  <Anchor data={item} variant={'transparent'}>
                    <div title={getSocialTitle(item)} dangerouslySetInnerHTML={{ __html: item.icono }} />
                  </Anchor>
                </SvgContainer>
              )
            );
          })}
        </HStack>
      </>
    </Box>
  );
};

const getSocialTitle = (item: SvgData) => {
  return item?.titulo ? item.titulo : 'Red social';
};

const SvgContainer = styled.div({ width: '30px', marginRight: '10px' });

const StyledSpan = styled(Span)<TypographyProps>(typography);
